<div class="project-risks">
    <app-project-library-items [projectDetails]="projectDetails" [libraryType]="libraryType" (projectDetailsChanged)="riskDetailsChanged($event)"></app-project-library-items>
</div>
